/* 菜单相关 */
import Vue from 'vue'
import {
  SET_MENUS,
  SET_MENUS_STATUS,
  SET_LEFT_MENUS,
  SET_FETCH_STATUS,
  SET_MENUS_VALUE,
  SET_NAV_BAR,
  SET_HIDE_LEFT_MENUS,
  SET_IS_MICRO,
  SET_IS_ASIDE_EXPAND
} from '/mutation-types'
import api from 'service'
import {findTopMenu, findActivePathChain, judgeApplicationPermissionByCookie} from '@/assets/utils'
import {getCookie} from '@/assets/utils/CommonUtil'
import commonService from '@/assets/service/common'
const state = {
  foldMenu: false,
  menuList: [], // 分角色获取的完整菜单数据
  leftMenus: [], // 当前左侧树形菜单数据
  hideLeftMenus: false, // 不显示左侧树形菜单
  activeMenuChain: [],
  databaseBlockRedirect: 0, // 电子档案室相关 模块自动跳转到有权限的菜单
  triggerMenuActiveChange: 0, // 刷新当前高亮状态菜单
  applicationStatusChange: 0, // 企业云产品权限状态获取完成
  applicationPermission: judgeApplicationPermissionByCookie(), // 企业云产品 权限列表
  nowModule: '', // 当前模块
  // 历史上传模块 菜单
  uploadHistory: [
    {
      id: 501,
      icon: 'w-icon-back',
      title: '返回主页',
      path: '/home'
    },
    {
      id: 502,
      icon: 'r2-icon-up',
      title: '上传中',
      isClick: true,
      path: '/upload/doing',
      children: [
        {
          id: 5021,
          // icon: 'w-icon-gongchengguanli',
          title: '工程上传记录',
          path: '/upload/doing/project'
        },
        {
          id: 5022,
          // icon: 'w-icon-yunshujuguanli',
          title: '数据上传记录',
          children: [
            {
              id: 50221,
              // icon: 'w-icon-shujuwenjian',
              title: '清单数据',
              path: '/upload/doing/list'
            },
            {
              id: 50222,
              // icon: 'w-icon-shujuwenjian',
              title: '组价数据',
              path: '/upload/doing/group'
            }
          ]
        }
      ]
    },
    {
      id: 503,
      icon: 'r2-icon-up2',
      title: '已上传',
      isClick: true,
      path: '/upload/done',
      children: [
        {
          id: 5031,
          // icon: 'w-icon-gongchengguanli',
          title: '工程上传记录',
          path: '/upload/done/project',
          point: false
        },
        {
          id: 5032,
          // icon: 'w-icon-yunshujuguanli',
          title: '数据上传记录',
          children: [
            {
              id: 50321,
              // icon: 'w-icon-shujuwenjian',
              title: '清单数据',
              path: '/upload/done/list',
              point: false
            },
            {
              id: 50322,
              // icon: 'w-icon-shujuwenjian',
              title: '组价数据',
              path: '/upload/done/group',
              point: false
            }
          ]
        }
      ]
    }
  ],
  // 意见反馈模块 菜单
  feedback: [
    {
      id: 601,
      icon: 'w-icon-back',
      title: '返回主页',
      path: '/home'
    },
    {
      id: 602,
      icon: 'w-icon-my_feedback',
      title: '意见反馈',
      path: '/feedback/add'
    },
    // {
    //   icon: 'w-icon-my_feedback',
    //   title: '反馈成功',
    //   path: '/feedback/success'
    // },
    {
      id: 603,
      icon: 'w-icon-advice_feedback',
      title: '我的反馈',
      path: '/feedback/list'
    }
  ],
  routeNow: {}, // 最新的 $route
  routeLast: {}, // 上一个 $route
  fetch: false, // 正在获取数据
  hideNavBar: false, // 不显示头部菜单
  isMicro: false,
  isAsideExpand: false
}

const mutations = {
  [SET_MENUS_STATUS] (state, status = true) {
    state.foldMenu = status
  },
  // 1. 将获取到的菜单 存放在store中
  [SET_MENUS] (state, list) {
    // const data = require('assets/js/menus.js').default
    const data = list // require('assets/js/menus.js').default //
    // 将接口返回数据 字段名称 对应到 菜单组件使用字段名称
    const formatData = (list) => {
      const result = []
      list.forEach((item) => {
        item.title = item.name || item.menuName // 咋成了menuName 说好的name呢
        item.path = item.routeName
        if (item.icon && !item.icon.includes('r2-icon-')) {
          item.icon = 'r2-icon-' + item.icon
        }
        if (item.childrenMenu && item.childrenMenu.length) {
          item.children = formatData(item.childrenMenu)
        } else {
          item.children = null
        }
        result.push(item)
      })

      return result
    }
    sessionStorage.removeItem('menuList')

    state.menuList = formatData(data)
    sessionStorage.setItem('menuList', JSON.stringify(state.menuList))

    // console.log('--------------')
  },
  // 2. 分模块设置左侧树形菜单
  [SET_LEFT_MENUS] (state) {
    if (!(/\/manage/.test(state.routeNow.path))) {
      // 1. 已删除人员 不修改菜单原有折叠状态 2. 进入其他页面是默认展开菜单
      state.foldMenu = false
    }
    let $route = {}
    if (state.routeNow.path !== state.routeLast.path) {
      $route = state.routeNow
      state.routeLast = state.routeNow
      const findMenuChain = () => {
        window.activeMenuChain = []
        switch (state.nowModule) {
          case '/upload':
            findActivePathChain($route.path, state.uploadHistory)
            break
          case '/feedback':
            findActivePathChain($route.path, state.feedback)
            break
          default:
            findActivePathChain($route.path, state.menuList)
            if (window.activeMenuChain && window.activeMenuChain.length && !/^\d+$/.test(window.activeMenuChain[0])) {
              window.activeMenuChain.shift()
            }
        }
        // console.log(window.activeMenuChain)
        // console.log('777777777777777777777')
        state.activeMenuChain = window.activeMenuChain
      }
      findTopMenu($route, state.menuList)
      if (state.nowModule && state.nowModule !== '/applications') {
        // 当前模块儿下路由切换 左侧树形菜单不用重新替换
        const reg = new RegExp('^' + state.nowModule)
        if (window.topMenuPath && reg.test(window.topMenuPath)) {
          findMenuChain()
          state.triggerMenuActiveChange++
          return
        }
      }
      state.nowModule = window.topMenuPath
      let hideLeftMenus = false
      let leftMenus = []
      if (state.nowModule) {
        switch (state.nowModule) {
          case '/upload':
            leftMenus = state.uploadHistory
            break
          case '/feedback':
            leftMenus = state.feedback
            break
          default:
            state.menuList.forEach((item) => {
              if (item.path === state.nowModule) {
                if (item.children && item.children.length) {
                  if (state.nowModule === '/applications') {
                    let routeNowTitle = state.routeNow.params.name || state.routeNow.meta.title
                    const findTargetMenu = (menu, routeNowTitle) => {
                      let flag = false
                      if (menu.title === routeNowTitle) {
                        flag = true
                      } else if (Array.isArray(menu.children) && menu.children.length) {
                        for (let i = 0; i < menu.children.length; i++) {
                          if (menu.children[i].title === routeNowTitle) {
                            flag = true
                            break
                          } else {
                            if (findTargetMenu(menu.children[i], routeNowTitle)) {
                              flag = true
                              break
                            }
                          }
                        }
                      }
                      return flag
                    }
                    if (Array.isArray(item.children) && item.children.length) {
                      item.children.forEach(child => {
                        if (findTargetMenu(child, routeNowTitle)) {
                          leftMenus = [child]
                        }
                      })
                    }
                  } else {
                    leftMenus = item.children
                    // if (state.nowModule === '/manage'){  //折叠左侧菜单列表
                    //   state.foldMenu = true
                    // }
                  }
                } else {
                  hideLeftMenus = true
                }
              }
            })
        }
      }
      // console.log(leftMenus)
      // console.log($route)
      // console.log(hideLeftMenus)
      state.hideLeftMenus = hideLeftMenus
      state.leftMenus = leftMenus
      findMenuChain()
      state.triggerMenuActiveChange++
      // 直接在地址栏输入 电子档案室相关页面地址时 若访问的无权访问的地址 则自动跳转到 左侧菜单 第一个有权限的页面
      if ($route.path === '/database') {
        state.databaseBlockRedirect++
      } else {
        if (/^\/database\//.test($route.path) && !/^\/database\/data\/record\//.test($route.path)) {
          let canVisit = false
          const judgeVisit = (menus) => {
            for (let i = 0; i < menus.length; i++) {
              if (menus[i].routeName === $route.path) {
                canVisit = true
                break
              } else {
                const reg = new RegExp('^' + menus[i].routeName)
                if (reg.test($route.path) && menus[i].childrenMenu && menus[i].childrenMenu.length) {
                  judgeVisit(menus[i].childrenMenu)
                }
              }
            }
          }
          judgeVisit(leftMenus)
          if (!canVisit) {
            state.databaseBlockRedirect++
          }
        }
      }
    }
  },
  // 3. 设置正在获取菜单
  [SET_FETCH_STATUS] (state, value) {
    state.fetch = value || false
  },
  // 设置值
  [SET_MENUS_VALUE] (state, {key, value}) {
    if (value !== undefined) {
      state[key] = value
    } else {
      state[key]++
    }
  },
  // 设置头部导航显隐
  [SET_NAV_BAR] (state, value) {
    state.hideNavBar = value || false
  },
  // 设置左侧导航菜单显隐
  [SET_HIDE_LEFT_MENUS] (state, value) {
    state.hideLeftMenus = value || false
  },
  // 是否微应用集成
  [SET_IS_MICRO] (state, value) {
    state.isMicro = value || false
  },
  // 平台菜单是否展开
  [SET_IS_ASIDE_EXPAND] (state, value) {
    state.isAsideExpand = value || false
  }
}


const actions = {
  // 1. 登录用户获取菜单
  initMenuData ({commit, state}) {
    const params = {
      language: 'cn',
      gray: getCookie('grayMenuDomain') || document.domain
    }
    const token = getCookie('ZJYTOKEN')
    let userInfo = getCookie('ZJYUSERINFO')
    if (token && userInfo) {
      userInfo = JSON.parse(userInfo)
      if (state.fetch) return
      commit(SET_FETCH_STATUS, true)
      let hasPermissionBasis = false // 是否展示造价依据库相关的菜单
      let list = []
      const task = {}
      const afterFetch = () => {
        if (task.database && task.menu) {
          console.log(hasPermissionBasis)
          // 没有电子档案室权限
          if (!hasPermissionBasis) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].routeName === '/database') {
                if (list[i].childrenMenu && list[i].childrenMenu.length) {
                  let idx = -1
                  for (let j = 0; j < list[i].childrenMenu.length; j++) {
                    console.log(list[i].childrenMenu[j].routeName)
                    if (list[i].childrenMenu[j].routeName === '/database/basis') {
                      idx = j
                      break
                    }
                  }
                  if (idx > -1) {
                    list[i].childrenMenu.splice(idx, 1)
                  }
                }
                break
              }
            }
          }
          // console.log(list)
          commit(SET_FETCH_STATUS)
          commit(SET_MENUS, list)
          commit(SET_LEFT_MENUS)
          commit(SET_MENUS_VALUE, {key: 'applicationStatusChange'})
          // commit('config/SET_LOADING', {key: 'contentBox', value: false}, { root: true })
        }
      }
      // 1.1 获取菜单数据
      api.common.queryMenuList(params).then(res => {
        list = res.data || []
        if (list.length) {
          list.forEach((item) => {
            // 获取 菜单中 企业数据库 下 各产品的权限
            if (item.routeName === '/applications') {
              const params = {}
              const findPermissions = (nowMenu) => {
                if (nowMenu['permissionId'] !== undefined && nowMenu['permissionId'] !== null && nowMenu['permissionId'] !== '') {
                  if (!params[nowMenu['permissionId']]) {
                    params[nowMenu['permissionId']] = []
                  }
                  if (nowMenu.gmsPids) {
                    params[nowMenu['permissionId']] = params[nowMenu['permissionId']].concat(nowMenu.gmsPids.split(','))
                  }
                }
                if (nowMenu.childrenMenu && nowMenu.childrenMenu.length) {
                  nowMenu.childrenMenu.forEach((m) => {
                    findPermissions(m)
                  })
                }
              }
              findPermissions(item)
              // console.dir(JSON.stringify(params))
              // console.log('-----------')
              api.common.getPermissionApplications(params).then(res => {
                // 返回 企业数据库 每个产品对应的权限
                if (+res.code === 200 && res.data) {
                  // if (Array.isArray(item.children) && item.children.length) {
                  //   item.children.forEach(it => {
                  //     it.hasPermission = res.data[it.permissionId]
                  //   })
                  // }
                  const applicationPermission = {}
                  for (const key in res.data) {
                    if (+key === 14) {
                      // 企业价格库 若工程材料库、询价材料库 有任意一个权限 则有 个人收藏的权限
                      applicationPermission[key] = res.data[9] || res.data[10] || false
                    } else {
                      applicationPermission[key] = res.data[key]
                    }
                  }
                  commit(SET_MENUS_VALUE, {
                    key: 'applicationPermission',
                    value: judgeApplicationPermissionByCookie(applicationPermission, params)
                  })
                }
              }).finally(() => {
                commit(SET_MENUS_VALUE, {key: 'applicationStatusChange'})
              })
            }
          })
        }
      }).finally(() => {
        task.menu = true
        afterFetch()
        // 获取子模块权限共享空间权限
        commonService.getUsePermissionApplications().then(data => {
          if (data.code === 200) {
            let modulePermission = {
              ROLE_QYDB_ESTI: false,
              ROLE_QYDB_LJ: false,
              ROLE_QYDB_GX: false
            } // 子模块系统权限
            if (data.data) {
              data.data.map((el) => {
                modulePermission[el.code] = true
              })
              addPermisstionList(list, modulePermission)
              commit('user/SET_PERMISSION', modulePermission['ROLE_QYDB_GX'], {root: true})
            }
            afterFetch()
          }
        })
        const addPermisstionList = (data, permistionObj) => {
          if (data && data.length){
            data.map((child) => {
              if (child.windowName) {
                child.modulePermission = permistionObj[child.windowName]
              }
              if (child.childrenMenu) {
                addPermisstionList(child.childrenMenu, permistionObj)
              }
            })
          }
        }
      })
      const role = getCookie('role')
      if (+role === 2 || +role === 3) {
        // 总负责人、 档案室负责人 有 电子档案室菜单
        hasPermissionBasis = true
        task.database = true
        afterFetch()
      } else {
        // 1.2 获取电子档案室 相关菜单权限
        api.common.getPermissionBasis().then(res => {
          // 通过返回值 判断是否有 电子档案室维护、管理 权限( 没有维护权限和管理权限的话 不显示“企业造价数据” 相关菜单)
          if (+res.code === 200 && res.data && res.data.length) {
            hasPermissionBasis = true
            const permissionObj = {
              permissionMajor: true,
              inventory: {},
              quota: {},
              combination: {},
              material: false
            }
            res.data.forEach((item) => {
              let typeName = ''
              switch (+item.dataType) {
                case 1:
                  typeName = 'inventory'
                  break
                case 2:
                  typeName = 'quota'
                  break
                case 3:
                  typeName = 'combination'
                  break
                case 4:
                  permissionObj.material = true
                  break
                default:
              }
              if (typeName) {
                permissionObj[typeName][item.catalogId] = true
              }
            })
            commit('config/SET_CONFIG_STATE', permissionObj, { root: true })
          }
          task.database = true
          afterFetch()
        }).catch((e) => {
          console.log(e)
          task.database = true
          afterFetch()
        })
      }
    } else {
      commit(SET_LEFT_MENUS)
    }
  },
  /* 2. 设置 左侧菜单栏数据
       每次路由切换之前都触发下 设置 左侧菜单
   */
  setLeftMenus ({commit, state, dispatch}, $route) {
    // if (!Vue.prototype.$microAppStore){
    //   if (/^\/applications/.test($route.path) && state.nowModule !== '/database') {
    //   // 电子档案室 模块 获取各个类型 下的专业和地区
    //     dispatch('database/getMajorAndRegion', '', { root: true })
    //   }
    //   commit(SET_MENUS_VALUE, {key: 'routeNow', value: $route}) // 目标路由暂存在store中
    //   if (!state.menuList.length) {
    //     dispatch('initMenuData')
    //   } else {
    //     commit(SET_LEFT_MENUS)
    //   }
    // }


  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
